module.exports = __webpack_public_path__ + "img/2.b535d762.png";